import { TranslationService } from '@sdbn/common';
import { TransportDetailsService } from './../../service/transport-details.service';
import { SelectionType } from '@sdbn/common';
import { Row } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { TmcTableModel } from '@sdbn/common';
import { TransportWeighing } from './../../model/transport-weighing';
import { Component, OnInit, Input } from '@angular/core';
import { ContextChange, DashboardContext } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { WidgetStyle } from '@sdbn/common';

@Component({
    selector: 'app-transport-weighings',
    templateUrl: './transport-weighings.component.html',
    styleUrls: ['./transport-weighings.component.scss'],
    standalone: false
})
export class TransportWeighingsComponent extends AbstractWidgetComponent {

  tableModel: TmcTableModel = new TmcTableModel();

  transportId: number;

  constructor(public translationService: TranslationService, private transportDetailsService: TransportDetailsService) {
    super();
    const prefix = 'tmc-yard.ui.transport.details.dialog.weighings.table.column.';
    this.tableModel.columnDefinitions = [
      { id: 'date', name: 'date', visible: true, type: ColumnType.STRING, translationKey: prefix + 'date' },
      { id: 'type', name: 'type', visible: true, type: ColumnType.DICTIONARY, translationKey: prefix + 'type' },
      { id: 'value', name: 'value', visible: true, type: ColumnType.STRING, translationKey: prefix + 'value' },
      { id: 'source', name: 'source', visible: true, type: ColumnType.DICTIONARY, translationKey: prefix + 'source' }
    ];

    this.tableModel.selectionType = SelectionType.NONE;
    this.tableModel.sortable = false;
    this.tableModel.filterable = false;
  }

  onContextChange(contextChange: ContextChange) {
    try {
      if (contextChange.key === 'selected-transport') {
        const selectedTransport = this.dashboardContext.context.get('selected-transport');
        if (selectedTransport != null && selectedTransport.id != null && selectedTransport.id !== this.transportId) {
          this.transportId = selectedTransport.id;
          this.loadWeighings();
        }
      }

      if (contextChange.key === 'transport-changed') {
        if (this.transportId != null) {
          this.loadWeighings();
        }
      }
    } catch (e) {
      this.tableModel.setRows(this.convertToTableRows(new Array<TransportWeighing>()));
    }
  }

  onSetElementAndContext() {
    const transport = this.dashboardContext.context.get('selected-transport');
    if (transport != null && transport.id != null) {
      this.transportId = transport.id;
      this.loadWeighings();
    }
  }

  private convertToTableRows(weighings: Array<TransportWeighing>): Row[] {
    const rows: Row[] = [];
    for (const w of weighings) {
      const row: Row = new Row();
      row.id = w.id + '';
      row.values = {
        id: w.id, date: w.date
      };
      row.values.value = w.value;
      row.values.type = 'tmc-yard.ui.transport.details.dialog.weighingType.' + w.type;
      row.values.source = 'tmc-yard.ui.transport.weighing.auto.sources.label.' + w.source;
      row.sortValues = { date: w.dateSortValue };

      rows.push(row);
    }
    return rows;
  }

  private loadWeighings() {
    this.transportDetailsService.getTransportWeighings({ id: this.transportId }).subscribe(
      transportWeighings => {
        this.tableModel.setRows(this.convertToTableRows(transportWeighings));
      }
    );
  }

  createPrintout() {
    this.transportDetailsService.createPrintout({ id: this.transportId });
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }

}
